const foldSearchText = (value) => String(value ?? '')
	.normalize('NFD')
	.replace(/[\u0300-\u036f]/g, '')
	.toLowerCase()

export const normalizeSidebarSearch = (value) => foldSearchText(value).trim()

export const matchesSidebarSearch = (values, query) => {
	const filter = normalizeSidebarSearch(query)
	return values.some(value => normalizeSidebarSearch(value).includes(filter))
}

// Map normalized matches back to the original spelling, including combining accents.
export const splitSidebarSearchMatches = (value, query) => {
	const text = String(value ?? '')
	const filter = normalizeSidebarSearch(query)
	if (!filter || !text) return [{ text, match: false }]

	let normalized = ''
	let offset = 0
	const positions = []
	for (const character of text) {
		const folded = foldSearchText(character)
		const end = offset + character.length
		for (let i = 0; i < folded.length; i += 1) {
			positions.push({ start: offset, end })
		}
		if (!folded && positions.length) positions[positions.length - 1].end = end
		normalized += folded
		offset = end
	}

	const parts = []
	let cursor = 0
	let matchIndex = normalized.indexOf(filter)
	while (matchIndex !== -1) {
		const start = positions[matchIndex].start
		const end = positions[matchIndex + filter.length - 1].end
		if (start > cursor) parts.push({ text: text.slice(cursor, start), match: false })
		parts.push({ text: text.slice(start, end), match: true })
		cursor = end
		matchIndex = normalized.indexOf(filter, matchIndex + filter.length)
	}
	if (cursor < text.length) parts.push({ text: text.slice(cursor), match: false })
	return parts
}
